import { render, staticRenderFns } from "./BaseFileDropZone.vue?vue&type=template&id=6cbaf79e&scoped=true&"
import script from "./BaseFileDropZone.vue?vue&type=script&lang=js&"
export * from "./BaseFileDropZone.vue?vue&type=script&lang=js&"
import style0 from "./BaseFileDropZone.vue?vue&type=style&index=0&id=6cbaf79e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cbaf79e",
  null
  
)

export default component.exports